import { render } from "./SheetImgQuoteView.vue?vue&type=template&id=d56633f2"
import script from "./SheetImgQuoteView.vue?vue&type=script&lang=js"
export * from "./SheetImgQuoteView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__